<template>
    <th
        colspan="1"
        rowspan="1"
        @click="sortValue()"
    >
        <div class="vs-table-text">
            <slot />
            <span
                v-if="isColumnSelectedForSort && currentSort != 0"
                class="sort-th"
            >
                <vs-icon
                    :icon="currentSort == 1 ? 'expand_less' : 'expand_more'"
                    class="th-sort-icon"
                />
            </span>
        </div>
    </th>
</template>
<script>
export default {
    name:  'VxTh',
    props: {
        sortKey: {
            default: null,
            type:    String,
        },
    },
    data: () => ({
        thIndex:      0,
        thwidth:      '100%',
        currentSort:  0,
        sortStatuses: [
            null,
            'asc',
            'desc',
        ],
    }),
    computed: {
        isColumnSelectedForSort() {
            if (!this.sortKey) {
                return false;
            }

            if (this.$parent.currentSortKey !== this.sortKey) {
                this.resetSort();
            }

            return this.$parent.currentSortKey === this.sortKey;
        },
        parentSortStatus() {
            return this.$parent.currentSortType;
        },
        styleth() {
            return {
                width: this.thwidth,
            };
        },
    },
    methods: {
        resetSort() {
            this.currentSort = 0;
        },
        sortValue() {
            this.currentSort = this.currentSort !== 2 ? this.currentSort + 1 : 0;
            this.$parent.sort(this.sortKey, this.sortStatuses[this.currentSort]);
        },
    },

};
</script>
